module.exports = __webpack_public_path__ + "static/media/waitListFirstScreen.520e9562.png";